'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { cn } from '@ncai-axe/react-ui-v3';
import styles from './styles.module.scss';
import { usePopover } from './PopoverContext';
export interface PopoverLayerProps extends React.ComponentPropsWithRef<'div'> {
  children: React.ReactNode;
  className?: string;
}
export default function PopoverLayer(t0) {
  const $ = _c(18);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const {
    method,
    openPopover,
    hidePopover
  } = usePopover();
  let t1;
  if ($[4] !== method || $[5] !== openPopover) {
    t1 = () => {
      if (method === "hover") {
        openPopover();
      }
    };
    $[4] = method;
    $[5] = openPopover;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const onMouseEnter = t1;
  let t2;
  if ($[7] !== hidePopover || $[8] !== method) {
    t2 = () => {
      if (method === "hover") {
        hidePopover();
      }
    };
    $[7] = hidePopover;
    $[8] = method;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const onMouseLeave = t2;
  let t3;
  if ($[10] !== className) {
    t3 = cn(styles.popoverLayer, className);
    $[10] = className;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== children || $[13] !== onMouseEnter || $[14] !== onMouseLeave || $[15] !== props || $[16] !== t3) {
    t4 = <div className={t3} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} {...props}>{children}</div>;
    $[12] = children;
    $[13] = onMouseEnter;
    $[14] = onMouseLeave;
    $[15] = props;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
PopoverLayer.displayName = 'Popover';